var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox-group',{attrs:{"value":_vm.value},on:{"input":_vm.emitInput}},_vm._l((_vm.options),function(mapper){return _c('el-checkbox',{key:mapper.value,attrs:{"label":mapper.value}},[_vm._v("\n    "+_vm._s(mapper.text)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b1d8e8d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/FwCheckboxGroup.vue
// module id = null
// module chunks = 